export const initInputSearch = () => {
  // Select all instances of the search component
  const searchComponents = document.querySelectorAll('.input-search');

  searchComponents.forEach((component) => {
    const searchInput = component.querySelector('.form-control');
    const clearBtn = component.lastElementChild;

    // Safety check: Ensure both exist and the last element isn't accidentally the input itself
    if (searchInput && clearBtn && searchInput !== clearBtn) {
      // Function to toggle visibility
      const toggleClearBtn = () => {
        if (searchInput.value.length > 0) {
          clearBtn.style.display = 'block';
        } else {
          clearBtn.style.display = 'none';
        }
      };

      // Run once on load (in case browser cached text)
      toggleClearBtn();

      // Listen for typing
      searchInput.addEventListener('input', toggleClearBtn);

      // Listen for click on the clear button
      clearBtn.addEventListener('click', function () {
        searchInput.value = ''; // Clear text
        toggleClearBtn(); // Hide button
        searchInput.focus(); // Return focus to input
      });
    }
  });
};
